import { render, staticRenderFns } from "./GradePublishSettings.vue?vue&type=template&id=786f5ce4&scoped=true"
import script from "./GradePublishSettings.vue?vue&type=script&lang=js"
export * from "./GradePublishSettings.vue?vue&type=script&lang=js"
import style0 from "./GradePublishSettings.vue?vue&type=style&index=0&id=786f5ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786f5ce4",
  null
  
)

export default component.exports